import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import PromoCodeLayer from '../components/PromoCodeLayer'

function PromoCodePage() {
  return (
    <>
    {/* Master Layouy */}
    <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title={'Promo Code'}/>

        {/* Promo Code Layer */}
        <PromoCodeLayer/>
    </MasterLayout>
    </>
  )
}

export default PromoCodePage